import { getPreferredPhone, useGetAllContacts } from "@api/contactService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ObjectInlineEdit from "@components/objects/ObjectInlineEdit";
import { useCreatePublicImprovement, useDeletePublicImprovement, useGetAllPublicImprovements, useUpdatePublicImprovement } from "@api/publicImprovementService";
import { formatCurrency } from "@utils/numbers";
import { formatDate } from "@utils/dates";
import { useCreateMembeshipLevel, useDeleteMembeshipLevel, useGetAllMembeshipLevels, useUpdateMembeshipLevel } from "@api/membershipLevelService";
import { useCreateTraining, useDeleteTraining, useGetAllTrainings, useUpdateTraining } from "@api/trainingService";
import { useCreateAppeal, useDeleteAppeal, useGetAllAppeals, useUpdateAppeal } from "@api/appealService";
import { useCreateFund, useDeleteFund, useGetAllFunds, useUpdateFund } from "@api/fundService";
import { useCreateRegistry, useDeleteRegistry, useGetAllRegistries, useUpdateRegistry } from "@api/registriesService";
import { useCreateZoning, useDeleteZoning, useGetAllZonings, useUpdateZoning } from "@api/zoningService";
import { useCreateSsa, useDeleteSsa, useGetAllSsas, useUpdateSsa } from "@api/ssaService";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        type: 'text',
        placeholder: 'e.g. MainStreet SSA',
        config: {
            required: true,
        },
        cell: (row, {LinkComponent}) => {
            // const LinkComponent = view === 'deleted' ? Box : Link;
            return (<>
                <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
            </>)
        }
      },
];

const listCell = (row, {LinkComponent}) => {
    return (<>
    {row.name !== row.company_name && (
        <Box sx={{mb: 1}}>
            <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    {row.name}
                </LinkComponent>
            </Typography>
            {row.company_name && (<Typography fontSize="sm">{row.company_name}</Typography>)}
        </Box>
    )}
    {row.name === row.company_name && (
        <Box sx={{mb: 1}}>
            <Typography>
                <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    {row.company_name}
                </LinkComponent>
            </Typography>
        </Box>
        )}
    </>);
};

const listActions = (row, {view, LinkComponent, ViewAction}) => {
    if(view === 'deleted') {
        return null;
    }

    return (<>
        <Tooltip title="Email">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!row.email}
                component={'a'}
                href={`mailto:${row.email}`}
                >
                <EmailRoundedIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Call">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!getPreferredPhone(row)}
                component={'a'}
                href={`tel:${getPreferredPhone(row)}`}
                >
                <LocalPhoneRoundedIcon />
            </IconButton>
        </Tooltip>
    </>);
};

export default function Ssas() {
    return (
        <ObjectInlineEdit
            query={useGetAllSsas}
            createMutation={useCreateSsa}
            updateMutation={useUpdateSsa}
            deleteMutation={useDeleteSsa}

            type={'ssa'}
            endpoint={'ssas'}
            permissionType={'settings'}
            title={'SSAs / BIDs'}
            color={'default'}
            columns={columns}
            listCell={listCell}
            listActions={listActions}
        />
    )
}
